import { FunctionComponent } from 'react';
import { LoadingIndicatorProps } from './LoadingIndicatorProps';

export const LoadingIndicator: FunctionComponent<LoadingIndicatorProps> = ({ description = 'Loading...' }) => {
  return (
    <div className="v-stack items-center space-y-1">
      <img className="w-10" src="/images/gifs/mario_walking.gif" alt="8-bit Mario walking" />
      {description ? <h5 className="text-text-secondary tracking-wide">{description}</h5> : undefined}
    </div>
  );
};
